import React, { useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom';


const ProjectStatusTable = ({ rows, currentPage, rowsPerPage, totalPages, onPageChange, sortConfig, onSort }) => {

    const navigate = useNavigate();


    const statusColors = {
        "Hold": "#D32F2F",
        "Abort": "#D32F2F",
        "Not Started": "#616161",
        "In Progress": "#1976D2",
        "Completed": "#2E7D32",
        "On Track": "#388E3C",
        "At Risk": "#EF6C00",
        "Behind": "#B71C1C",
    };

    const handleSort = (key) => {
        const direction = sortConfig.key === key && sortConfig.direction === "asc" ? "desc" : "asc";
        onSort({ key, direction });
    };




    const headers = [
        { key: "project_code", label: "Project Code" },
        { key: "project_name", label: "Project Name" },
        { key: 'spi', label: 'SPI' },
        { key: 'cpi', label: 'CPI' },
        { key: "status", label: "Status" },
        { key: "manager", label: "Manager" },
        { key: "end_date", label: "Date" },
        { key: "completion_percentage", label: "Completion" },
    ];


    return (
        <div style={{ width: "100%", overflowX: "auto", margin: "20px 0" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", minWidth: "600px", borderRadius: "5px" }}>
                <thead>
                    <tr>
                        {headers.map((header) => (
                            <th
                                key={header.key}
                                onClick={() => handleSort(header.key)}
                                style={{
                                    border: "1px solid #ddd",
                                    padding: "8px",
                                    textAlign: "left",
                                    background: "#004a78",
                                    color: "#fff",
                                    fontWeight: "600",
                                    fontSize: "14px",
                                    position: "sticky",
                                    top: 0,
                                    cursor: "pointer",
                                }}
                            >
                                {header.label}{" "}
                                {sortConfig.key === header.key ? (sortConfig.direction === "asc" ? "▲" : "▼") : ""}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row, i) => (
                        <tr key={i} style={{ borderBottom: "1px solid #eee", fontSize: "10px" }}>
                            <td style={{ padding: "10px", border: "1px solid #ddd" }}>{row.code}</td>
                            <td style={{ padding: "10px", border: "1px solid #ddd", cursor: "pointer" }}
                                onClick={() => navigate("/project-dashboard", { state: { id: row.id } })}>{row.name}</td>
                            <td style={{ padding: "10px", border: "1px solid #ddd" }}>{row.spi}</td>
                            <td style={{ padding: "10px", border: "1px solid #ddd" }}>{row.cpi}</td>
                            <td
                                style={{
                                    padding: "10px",
                                    border: "1px solid #ddd",
                                    fontWeight: "600",
                                    color: statusColors[row.status] || "#000",
                                }}
                            >
                                {row.status}
                            </td>
                            <td style={{ padding: "10px", border: "1px solid #ddd" }}>{row.manager}</td>
                            <td style={{ padding: "10px", border: "1px solid #ddd" }}>{row.date}</td>
                            <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                    <div
                                        style={{
                                            flexGrow: 1,
                                            height: "6px",
                                            borderRadius: "8px",
                                            background: "#e0e0e0",
                                            position: "relative",
                                            overflow: "hidden",
                                        }}
                                    >
                                        <div
                                            style={{
                                                width: `${row.completion}%`,
                                                height: "100%",
                                                background:
                                                    row.completion >= 80
                                                        ? "#2E7D32"
                                                        : row.completion >= 50
                                                            ? "#1976D2"
                                                            : "#D32F2F",
                                                borderRadius: "8px",
                                                transition: "width 0.3s ease",
                                            }}
                                        />
                                    </div>
                                    <span style={{ fontWeight: "600", minWidth: "40px" }}>{row.completion}%</span>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>


            <div style={{ display: "flex", justifyContent: "center", marginTop: "12px", gap: "10px", alignItems: "center" }}>
                <button
                    onClick={() => onPageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    style={{ padding: "5px 10px", borderRadius: "10px", cursor: "pointer" }}
                >
                    Prev
                </button>
                <span style={{ fontSize: "14px" }}>
                    Page {currentPage} of {totalPages}
                </span>
                <button
                    onClick={() => onPageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    style={{ padding: "5px 10px", borderRadius: "10px", cursor: "pointer" }}
                >
                    Next
                </button>
            </div>
        </div >
    )
}

export default ProjectStatusTable
